import More from '@/assets/images/common/svg/more.svg?react';
import styles from './index.module.scss';
import type { ListProps } from './interface';

export default function List({
  icon,
  title,
  desc,
  descLink,
  onClick,
  onDoubleClick,
  content,
  style,
  gap,
  operationIcon = <More />,
}: ListProps) {
  return (
    <div
      className={styles.list}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      style={{
        ...style,
        gap,
      }}
    >
      {icon}
      <div className={styles.content}>
        <div className={styles.title}>{title}</div>
        {desc && (
          <div className={cls(styles.desc, descLink && styles.descLink)}>{desc}</div>
        )}
      </div>
      {content}
      {operationIcon}
    </div>
  );
}
